import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { neutrals } from 'src/theme/colors';
import { LookupCodes } from 'src/constants/lookup.constants';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { LookupIconNamesMap } from 'src/constants/lookup.constants';

export const LookupIcon = ({ lookup_code }: { lookup_code: LookupCodes }) => {
  const iconName = LookupIconNamesMap[lookup_code as LookupCodes] ?? ICON_NAMES.Circle; // fallback per default
  return <Icon name={iconName} color={neutrals.neutralGrays.ash} />;
};
